import React, { useState } from "react";
import { assetUrl } from "../../../utils/assets";

interface SubMethod {
    id: number;
    name: string;
    code: string;
    image_url: string;
}

interface PaymentMethod {
    id: number;
    name: string;
    image_url: string;
    method: SubMethod[];
}

interface PaymentMethodsProps {
    paymentMethods: PaymentMethod[];
    onSelect: (id: number, methodData: SubMethod) => void;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ paymentMethods, onSelect }) => {
    const [openMethodId, setOpenMethodId] = useState<number | null>(null);
    const [selectedId, setSelectedId] = useState<number | null>(null);

    const toggleMethod = (id: number) => {
        setOpenMethodId((prevId) => (prevId === id ? null : id));
    };

    const handleChange = (subMethod: SubMethod) => {
        setSelectedId(subMethod.id);
        onSelect(subMethod.id, subMethod);
    };

    const handleDirectSelect = (method: PaymentMethod, sub: SubMethod) => {
        setSelectedId(sub.id);
        onSelect(sub.id, sub);
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow-sm border space-y-3">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <img src={assetUrl("images/vector.svg")} alt="Metode Pembayaran" className="w-5 h-5" />
                    <p className="font-medium text-sm">Metode Pembayaran</p>
                </div>
            </div>

            {paymentMethods.map((method) => {
                const isQRIS = method.name.toLowerCase().includes("qris");

                if (isQRIS && method.method.length > 0) {
                    const sub = method.method[0];
                    return (
                        <label
                            key={method.id}
                            className="flex items-center justify-between cursor-pointer py-2"
                        >
                            <div className="flex gap-2 items-center">
                                <img src={method.image_url} alt={method.name} className="w-6 h-6" />
                                <p className="text-sm font-semibold">{method.name}</p>
                            </div>
                            <input
                                type="radio"
                                name="payment"
                                value={sub.id}
                                className="accent-blue-600"
                                checked={selectedId === sub.id}
                                onChange={() => handleDirectSelect(method, sub)}
                            />
                        </label>
                    );
                }

                return (
                    <div key={method.id}>
                        <button
                            onClick={() => toggleMethod(method.id)}
                            className="w-full text-left flex items-center justify-between py-2"
                        >
                            <div className="flex gap-2 items-center">
                                <img src={method.image_url} alt={method.name} className="w-5 h-5" />
                                <p className="text-sm font-semibold">{method.name}</p>
                            </div>
                            <span className="text-xs text-gray-500">
                                {openMethodId === method.id ? "▲" : "▼"}
                            </span>
                        </button>

                        {openMethodId === method.id && (
                            <div className="space-y-2 pl-6 pt-2">
                                {method.method.map((sub) => (
                                    <label
                                        key={sub.id}
                                        className="flex items-center justify-between cursor-pointer"
                                    >
                                        <div className="flex gap-2 items-center">
                                            <img src={sub.image_url} alt={sub.name} className="w-8 h-4" />
                                            <p className="text-sm">{sub.name}</p>
                                        </div>
                                        <input
                                            type="radio"
                                            name="payment"
                                            value={sub.id}
                                            className="accent-blue-600"
                                            checked={selectedId === sub.id}
                                            onChange={() => handleChange(sub)}
                                        />
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default PaymentMethods;
